/* eslint-disable parse/no-tailwind-z-index */
import { FaTimes } from 'react-icons/fa'

const KSClientPdfSplitImageModal = ({
    src,
    title,
    onClose,
}) => {
    
    return (<>
        
        <header className="fixed inset-0 h-12 z-[10001] w-auto max-w-screen-2xl mx-auto
            flex items-center justify-between bg-accent p-3">
            <div>{title ?? ' '}</div>
            <FaTimes
                className="h-6 w-6 hover:text-secondary cursor-pointer"
                onClick={onClose}/>
        </header>
        
        <div className="fixed inset-3 top-12 z-[10000] h-screen w-auto max-w-screen-2xl mx-auto
            bg-white border-4 border-accent overflow-y-auto">
            
            <img src={src} alt={`${title}??`}/>
        
        </div>
    
    </>)
    
}

export default KSClientPdfSplitImageModal
